<script setup>

import {useCheckFieldsForData} from "@/composables/common/useCheckFieldsForData";
import {ref, computed} from 'vue';

const tileColour = computed(() => {

  return props.tileColor

})

const props = defineProps ({

  viewModel: {},
  tileSelectionModel: {},
  validationProp: Boolean,
  useIcons: {type:Boolean, default: true},
  tileColor: {type: String, default: '#c9c8c7'},
})

const emits = defineEmits(['select'])

</script>
<template class="cmp-section-tile">
  <div class="cmp-section-tile_tile" :class="{'cmp-section-tile_active' : props.tileSelectionModel}"
       @click="emits('select')">
    <div class=" cmp-section-tile_icon"><slot name="icon"></slot></div>
    <div class="cmp-section-tile_tile-title"><slot name="title"></slot>
      <div class="cmp-section-tile_tile-description"><slot name="description"></slot></div>
    </div>
    <div>
      <i v-if="!props.tileSelectionModel"
         class="fa-regular fa-angle-down cmp-section-tile_lower-icon-button"
         style="color: #f57a1d; font-size: 28px;">
      </i>
      <i v-if="props.tileSelectionModel"
         class="fa-regular fa-angle-down cmp-section-tile_lower-icon-button-open"
         style="color: #0ad42e;">
      </i>
      <i v-if="useCheckFieldsForData(props.viewModel) && props.validationProp && !props.tileSelectionModel"
         class="fa-regular fa-shield-check cmp-section-tile_success-icon-button"
         style="color: #7ce93d;" title="Fields have data and any validation is correct">
      </i>
      <div v-if="!props.validationProp && props.useIcons" class="cmp-section-tile_upper-icon-button">
        <i class="fa-solid fa-triangle-exclamation" style="color: #ffc600" title="Please Fill All Required Fields"></i>
      </div>
      <span v-if="!props.validationProp && props.useIcons" class="cmp-section-tile_validation-message">Required Fields</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.cmp-section-tile {

  &_tile {
    position: relative;
    height: 70px;
    width: auto;
    border-radius: 6px;
    //background-image: linear-gradient(0deg, #5d8fa1, #173746);
    background: v-bind(tileColour);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
    gap: 20px;
    cursor: pointer;
  }

  &_icon {
    font-size: 40px;
    color: white;
  }

  &_tile-title {
    color: white;
    font-size: 15px;
    font-weight: bold;
  }

  &_tile-description {
    font-size: 11px;
    font-weight: normal;
    width: max-content;
  }

  &_tile:hover, &_active {
    opacity: 0.9;
  }

  &_lower-icon-button {
    position: absolute;
    font-size: 18px;
    bottom: 0px;
    right: 6px;
    cursor: pointer;
  }

  &_success-icon-button {
    position: absolute;
    font-size: 20px;
    top: 6px;
    right: 7px;
    cursor: default;
  }

  &_lower-icon-button-open {
    position: absolute;
    font-size: 40px;
    right: 2px;
    cursor: pointer;
  }

  &_upper-icon-button {
    position: absolute;
    font-size: 20px;
    top: 2px;
    right: 8px;
    cursor: default;
  }

  &_validation-message {
    font-size: 10px;
    color: #ffbf0a;
    position: absolute;
    bottom: 2px;
    left: 10px;
  }

}

</style>
